// SPDX-FileCopyrightText: Copyright (c) 2025-2026, NVIDIA CORPORATION & AFFILIATES. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

export const EMPTY_RESEARCH_DETAILS_HELP_TEXT =
  'These details appear during active research and may not be available for completed reports.'
